// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background: white;
    position: relative;
    overflow: hidden;
  }
  
  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    padding: 2rem;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0 8px 32px rgba(102, 22, 205, 0.15);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    max-width: 90%;
    width: 400px;
  }
  
  /* Animated Logo */
  .loading-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: 1px;
  }
  
  .loading-logo span {
    display: inline-block;
    color: #6616cd;
    animation: bounce 1.5s ease infinite;
    animation-delay: calc(0.1s * var(--i));
    opacity: 0;
  }
  
  .loading-logo span:nth-child(1) { --i: 1; }
  .loading-logo span:nth-child(2) { --i: 2; }
  .loading-logo span:nth-child(3) { --i: 3; }
  .loading-logo span:nth-child(4) { --i: 4; }
  .loading-logo span:nth-child(5) { --i: 5; }
  .loading-logo span:nth-child(6) { --i: 6; }
  .loading-logo span:nth-child(7) { --i: 7; }
  .loading-logo span:nth-child(8) { --i: 8; }
  .loading-logo span:nth-child(9) { --i: 9; }
  
  @keyframes bounce {
    0%, 20% {
      transform: translateY(0);
      opacity: 0;
    }
    40% {
      transform: translateY(-15px);
      opacity: 1;
    }
    60% {
      transform: translateY(0);
      opacity: 1;
    }
    80%, 100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Loading Animation */
  .loading-animation {
    position: relative;
    width: 100px;
    height: 100px;
    margin-bottom: 2rem;
  }
  
  .loading-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 5px solid rgba(102, 22, 205, 0.1);
    border-radius: 50%;
    border-top-color: rgba(102, 22, 205, 0.8);
    animation: spin 1s ease-in-out infinite;
  }
  
  .loading-circles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  .circle {
    position: absolute;
    background: rgba(102, 22, 205, 0.6);
    border-radius: 50%;
    transform: scale(0);
  }
  
  .circle-1 {
    width: 15px;
    height: 15px;
    top: 10%;
    left: 50%;
    margin-left: -7.5px;
    animation: pulse-circle 2s ease-in-out infinite;
  }
  
  .circle-2 {
    width: 12px;
    height: 12px;
    top: 50%;
    left: 15%;
    margin-top: -6px;
    animation: pulse-circle 2s ease-in-out infinite 0.5s;
  }
  
  .circle-3 {
    width: 10px;
    height: 10px;
    bottom: 20%;
    right: 20%;
    animation: pulse-circle 2s ease-in-out infinite 1s;
  }
  
  @keyframes pulse-circle {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    50% {
      transform: scale(1);
      opacity: 0.5;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  /* Text Styles */
  .loading-text {
    font-size: 1.5rem;
    color: #6616cd;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    animation: pulse 1.5s ease-in-out infinite;
    text-align: center;
  }
  
  .loading-subtext {
    font-size: 1rem;
    color: #8a56c9;
    font-weight: 400;
    margin: 0;
    opacity: 0.8;
    text-align: center;
  }
  
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
  
  /* Background Particles */
  .loading-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  
  .particle {
    position: absolute;
    background: linear-gradient(135deg, #6616cd 0%, #a64efd 100%);
    border-radius: 50%;
    opacity: 0.2;
    animation: float 15s ease-in-out infinite;
  }
  
  .particle-1 {
    width: 100px;
    height: 100px;
    top: 10%;
    left: 10%;
    animation-delay: 0s;
  }
  
  .particle-2 {
    width: 150px;
    height: 150px;
    top: 60%;
    left: 80%;
    animation-delay: 2s;
    background: linear-gradient(135deg, #a64efd 0%, #ff9edb 100%);
  }
  
  .particle-3 {
    width: 80px;
    height: 80px;
    top: 80%;
    left: 20%;
    animation-delay: 4s;
    background: linear-gradient(135deg, #ff9edb 0%, #6616cd 100%);
  }
  
  .particle-4 {
    width: 120px;
    height: 120px;
    top: 30%;
    left: 90%;
    animation-delay: 6s;
  }
  
  .particle-5 {
    width: 70px;
    height: 70px;
    top: 70%;
    left: 50%;
    animation-delay: 8s;
    background: linear-gradient(135deg, #8a56c9 0%, #6616cd 100%);
  }
  
  .particle-6 {
    width: 200px;
    height: 200px;
    top: 20%;
    left: 40%;
    animation-delay: 10s;
    opacity: 0.1;
  }
  
  @keyframes float {
    0% {
      transform: translate(0, 0) rotate(0deg);
    }
    25% {
      transform: translate(10px, 10px) rotate(5deg);
    }
    50% {
      transform: translate(0, 20px) rotate(0deg);
    }
    75% {
      transform: translate(-10px, 10px) rotate(-5deg);
    }
    100% {
      transform: translate(0, 0) rotate(0deg);
    }
  }
  
  /* Responsive Adjustments */
  @media (max-width: 768px) {
    .loading-content {
      width: 85%;
      padding: 1.5rem;
    }
    
    .loading-logo {
      font-size: 2rem;
    }
    
    .loading-animation {
      width: 80px;
      height: 80px;
    }
    
    .loading-text {
      font-size: 1.2rem;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,+CAA+C;IAC/C,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;IAC1C,cAAc;IACd,YAAY;EACd;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,oCAAoC;IACpC,sCAAsC;IACtC,UAAU;EACZ;;EAEA,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;EAC1C,kCAAkC,MAAM,EAAE;;EAE1C;IACE;MACE,wBAAwB;MACxB,UAAU;IACZ;IACA;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,yCAAyC;IACzC,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,oDAAoD;EACtD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kDAAkD;EACpD;;EAEA;IACE;MACE,mBAAmB;MACnB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,qBAAqB;MACrB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE;MACE,YAAY;IACd;IACA;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;EACF;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,6DAA6D;IAC7D,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,6DAA6D;EAC/D;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,6DAA6D;EAC/D;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,6DAA6D;EAC/D;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE;MACE,uCAAuC;IACzC;IACA;MACE,6CAA6C;IAC/C;IACA;MACE,0CAA0C;IAC5C;IACA;MACE,+CAA+C;IACjD;IACA;MACE,uCAAuC;IACzC;EACF;;EAEA,2BAA2B;EAC3B;IACE;MACE,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".loading-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background: white;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .loading-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    padding: 2rem;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.85);\n    box-shadow: 0 8px 32px rgba(102, 22, 205, 0.15);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    max-width: 90%;\n    width: 400px;\n  }\n  \n  /* Animated Logo */\n  .loading-logo {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 2rem;\n    font-size: 2.5rem;\n    font-weight: 700;\n    letter-spacing: 1px;\n  }\n  \n  .loading-logo span {\n    display: inline-block;\n    color: #6616cd;\n    animation: bounce 1.5s ease infinite;\n    animation-delay: calc(0.1s * var(--i));\n    opacity: 0;\n  }\n  \n  .loading-logo span:nth-child(1) { --i: 1; }\n  .loading-logo span:nth-child(2) { --i: 2; }\n  .loading-logo span:nth-child(3) { --i: 3; }\n  .loading-logo span:nth-child(4) { --i: 4; }\n  .loading-logo span:nth-child(5) { --i: 5; }\n  .loading-logo span:nth-child(6) { --i: 6; }\n  .loading-logo span:nth-child(7) { --i: 7; }\n  .loading-logo span:nth-child(8) { --i: 8; }\n  .loading-logo span:nth-child(9) { --i: 9; }\n  \n  @keyframes bounce {\n    0%, 20% {\n      transform: translateY(0);\n      opacity: 0;\n    }\n    40% {\n      transform: translateY(-15px);\n      opacity: 1;\n    }\n    60% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n    80%, 100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  \n  /* Loading Animation */\n  .loading-animation {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin-bottom: 2rem;\n  }\n  \n  .loading-spinner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 5px solid rgba(102, 22, 205, 0.1);\n    border-radius: 50%;\n    border-top-color: rgba(102, 22, 205, 0.8);\n    animation: spin 1s ease-in-out infinite;\n  }\n  \n  .loading-circles {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .circle {\n    position: absolute;\n    background: rgba(102, 22, 205, 0.6);\n    border-radius: 50%;\n    transform: scale(0);\n  }\n  \n  .circle-1 {\n    width: 15px;\n    height: 15px;\n    top: 10%;\n    left: 50%;\n    margin-left: -7.5px;\n    animation: pulse-circle 2s ease-in-out infinite;\n  }\n  \n  .circle-2 {\n    width: 12px;\n    height: 12px;\n    top: 50%;\n    left: 15%;\n    margin-top: -6px;\n    animation: pulse-circle 2s ease-in-out infinite 0.5s;\n  }\n  \n  .circle-3 {\n    width: 10px;\n    height: 10px;\n    bottom: 20%;\n    right: 20%;\n    animation: pulse-circle 2s ease-in-out infinite 1s;\n  }\n  \n  @keyframes pulse-circle {\n    0% {\n      transform: scale(0);\n      opacity: 1;\n    }\n    50% {\n      transform: scale(1);\n      opacity: 0.5;\n    }\n    100% {\n      transform: scale(1.5);\n      opacity: 0;\n    }\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  /* Text Styles */\n  .loading-text {\n    font-size: 1.5rem;\n    color: #6616cd;\n    font-weight: 600;\n    margin: 0 0 0.5rem 0;\n    animation: pulse 1.5s ease-in-out infinite;\n    text-align: center;\n  }\n  \n  .loading-subtext {\n    font-size: 1rem;\n    color: #8a56c9;\n    font-weight: 400;\n    margin: 0;\n    opacity: 0.8;\n    text-align: center;\n  }\n  \n  @keyframes pulse {\n    0% {\n      opacity: 0.6;\n    }\n    50% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.6;\n    }\n  }\n  \n  /* Background Particles */\n  .loading-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n  }\n  \n  .particle {\n    position: absolute;\n    background: linear-gradient(135deg, #6616cd 0%, #a64efd 100%);\n    border-radius: 50%;\n    opacity: 0.2;\n    animation: float 15s ease-in-out infinite;\n  }\n  \n  .particle-1 {\n    width: 100px;\n    height: 100px;\n    top: 10%;\n    left: 10%;\n    animation-delay: 0s;\n  }\n  \n  .particle-2 {\n    width: 150px;\n    height: 150px;\n    top: 60%;\n    left: 80%;\n    animation-delay: 2s;\n    background: linear-gradient(135deg, #a64efd 0%, #ff9edb 100%);\n  }\n  \n  .particle-3 {\n    width: 80px;\n    height: 80px;\n    top: 80%;\n    left: 20%;\n    animation-delay: 4s;\n    background: linear-gradient(135deg, #ff9edb 0%, #6616cd 100%);\n  }\n  \n  .particle-4 {\n    width: 120px;\n    height: 120px;\n    top: 30%;\n    left: 90%;\n    animation-delay: 6s;\n  }\n  \n  .particle-5 {\n    width: 70px;\n    height: 70px;\n    top: 70%;\n    left: 50%;\n    animation-delay: 8s;\n    background: linear-gradient(135deg, #8a56c9 0%, #6616cd 100%);\n  }\n  \n  .particle-6 {\n    width: 200px;\n    height: 200px;\n    top: 20%;\n    left: 40%;\n    animation-delay: 10s;\n    opacity: 0.1;\n  }\n  \n  @keyframes float {\n    0% {\n      transform: translate(0, 0) rotate(0deg);\n    }\n    25% {\n      transform: translate(10px, 10px) rotate(5deg);\n    }\n    50% {\n      transform: translate(0, 20px) rotate(0deg);\n    }\n    75% {\n      transform: translate(-10px, 10px) rotate(-5deg);\n    }\n    100% {\n      transform: translate(0, 0) rotate(0deg);\n    }\n  }\n  \n  /* Responsive Adjustments */\n  @media (max-width: 768px) {\n    .loading-content {\n      width: 85%;\n      padding: 1.5rem;\n    }\n    \n    .loading-logo {\n      font-size: 2rem;\n    }\n    \n    .loading-animation {\n      width: 80px;\n      height: 80px;\n    }\n    \n    .loading-text {\n      font-size: 1.2rem;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
